import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Loginpage from './pages/login';
import Event from './pages/Eventmangement';
import Bookingmangemnet from './pages/Event_booking';
import Categorypage from './pages/Categories_management';
import USERR from './pages/Users Management';
import Supportmsg from './pages/supportmsg';
import Feedbackkmsg from './pages/Feedback';

import Contentmangementevent from './pages/content_mangement._events';
import ContentmangementCategory from './pages/Categorycontentmangement';
import Contentmangementwhychooseus from './pages/Contentmangementwhychooseus';
import Contentmangementnavss from './pages/content_mangement_nav';
import Contentmangementfeedback from './pages/content-mangement-feedback';
import Contentmangemntnav from './pages/content_mangement_nav';
import Contentmangementfaqs from './pages/content-mangement-faqs';






const Paths = () => {
    return ( 
        <>
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Loginpage />} />
                    <Route path='/home-page' element={<Home/>} />
                    <Route path='/event-mangement-page' element={ <Event />} />
                    <Route path='/booking-mangement-page' element={ <Bookingmangemnet /> } />   
                     <Route path='/Categories_management-page' element={ <Categorypage /> } />        
                     <Route path='/Users_Management-page' element={  <USERR />} />       
                      <Route path='/Support-Management-page' element={  <Supportmsg />} />   
                     <Route path='/Feedback_Management-page' element={  <Feedbackkmsg />   } />   
                     <Route path='/Event-content_Management-page' element={ <Contentmangementevent />} /> 
                     <Route path='/Category-content_Management-page' element={ <ContentmangementCategory />} />    
                     <Route path='/About-content_Management-page' element={ <Contentmangementwhychooseus />} />  
                     <Route path='/Navs_content_Management-page' element={<Contentmangementnavss />} />  
                     <Route path='/Feedback_content_Management-page' element={<Contentmangementfeedback />} /> 
                     <Route path='/FAQs_content_Management-page' element={ <Contentmangementfaqs />} /> 

                   
                </Routes>
            </BrowserRouter>
        </>
     );
}
 
export default Paths;